import { computed } from 'vue';
import { useCoreStore } from 'src/stores/core/store';
import { AppCoreEnums } from 'src/core/shared/enums';
import useUserPreferences from '../use-user-preferences';
import { saveUserPreference } from 'src/core/utils/user-preferences-utils';
import useContainerDynamicFiltersStore from './use-container-dynamic-filters-store';
import { IDynamicFilterItem, IDynamicFilterValueOptions } from 'src/stores/core/models';

export default (containerType: AppCoreEnums.ContainerType) => {
  const coreStore = useCoreStore();

  const { getDynamicFiltersPreferenceKey } = useUserPreferences();
  const { addContainerDynamicFilter, removeContainerDynamicFilter, getTableBasedContainerData, resetContainerDynamicFilters } =
    useContainerDynamicFiltersStore();

  const addDynamicFilterItem = (dynamicFilterItem: IDynamicFilterItem, mergeExistingValues = false) => {
    addContainerDynamicFilter(containerType, dynamicFilterItem, mergeExistingValues);
    coreStore.refreshTableBasedContainer(containerType);
    coreStore.resetContainerSelectedRows(containerType);
    saveDynamicFiltersAsUserPreference();
  };

  const removeDynamicFilterItem = (dynamicFilterItem: IDynamicFilterItem, mergeExistingValues = false) => {
    removeContainerDynamicFilter(containerType, dynamicFilterItem, mergeExistingValues);
    coreStore.refreshTableBasedContainer(containerType);
    coreStore.resetContainerSelectedRows(containerType);

    saveDynamicFiltersAsUserPreference();
  };

  const saveDynamicFiltersAsUserPreference = () => {
    saveUserPreference({
      preferenceKey: getDynamicFiltersPreferenceKey(containerType),
      preferenceValue: JSON.stringify(containerDynamicFilters.value || []),
    });
  };

  const clearDynamicFilters = () => {
    resetContainerDynamicFilters(AppCoreEnums.ContainerType.CollapsibleTableContainer, true);
    resetContainerDynamicFilters(AppCoreEnums.ContainerType.TableContainer, true);
    resetContainerDynamicFilters(AppCoreEnums.ContainerType.TableInnerContainer, true);

    saveDynamicFiltersAsUserPreference();

    coreStore.collapsibleTableContainerData.refreshRequestCount++;
    coreStore.tableContainerData.refreshRequestCount++;
  };

  const containerDynamicFilters = computed(() => getTableBasedContainerData(containerType).value.dynamicFilters);

  const containerDynamicFilterKeys = computed(() => containerDynamicFilters.value.map((x) => x.key));

  const syncDynamicFilterOptionsWithItems = (filterOptions: IDynamicFilterValueOptions[]) => {
    const containerData = getTableBasedContainerData(containerType);

    containerData.value.dynamicFilterOptions = filterOptions;

    containerData.value.dynamicFilters?.forEach((x) => {
      const relatedOptions = filterOptions?.find((y) => y.key === x.key);
      if (relatedOptions) x.isStickyInternal = relatedOptions.isSticky;
    });
  };

  return {
    clearDynamicFilters,
    addDynamicFilterItem,
    removeDynamicFilterItem,
    containerDynamicFilters,
    containerDynamicFilterKeys,
    saveDynamicFiltersAsUserPreference,
    syncDynamicFilterOptionsWithItems,
  };
};
